import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Core2Config } from '../shared';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { HcConsultationPrescriptionMedicineLinkContainerModel } from '../../../../../models/aggregates/healthcare/consultation_prescription_medicine_link.model';

@Injectable({ providedIn: 'root' })
export class HcConsultationPrescriptionMedicineLinkLoginEpService extends BaseApiTemplateService<HcConsultationPrescriptionMedicineLinkContainerModel> {
    readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + "consultation-prescription-medicine-links";

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + 'consultation-prescription-medicine-links/' + Core2Config.LOGIN_EP_SUFFIX;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + 'consultation-prescription-medicine-links/' + Core2Config.LOGIN_EP_SUFFIX;
        this.httpClient = http;
    }
}